import React, { useState, useEffect } from "react";
import style from "./HeadingBar.module.css";
import starimg from "./assets/starimg.png";
import logoutimg from "./assets/logout.png";
import { useNavigate } from "react-router-dom";

const HeadingBar = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    sessionStorage.clear();
    navigate("/login");
  };

  const getGreetingData = () => {
    const now = new Date();
    const hour = now.getHours();

    let greeting;
    let icon;

    if (hour >= 5 && hour < 12) {
      greeting = "Good Morning";
      icon = "☀️";
    } else if (hour >= 12 && hour < 18) {
      greeting = "Good Afternoon";
      icon = "🌤️";
    } else {
      greeting = "Good Evening";
      icon = "🌙";
    }

    const timeString = now.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
    });

    return { greeting, icon, timeString };
  };

  const [greetingData, setGreetingData] = useState(() => getGreetingData());
  const [vendorName, setVendorName] = useState("");
  const [CardName, setCardName] = useState("");
  useEffect(() => {
    const updateTime = () => {
      setGreetingData(getGreetingData());
    };

    updateTime();

    const now = new Date();
    const delay = (60 - now.getSeconds()) * 1000;

    const timeout = setTimeout(() => {
      updateTime();
      const interval = setInterval(updateTime, 60000);
      return () => clearInterval(interval);
    }, delay);

    return () => clearTimeout(timeout);
  }, []);

  // read from session storage
  useEffect(() => {
    const storedData = JSON.parse(sessionStorage.getItem("vendordata"));
    if (storedData?.Name) {
      setVendorName(storedData.Name);
    }
    if (storedData?.CardName) {
      setCardName(storedData.CardName);
    }
  }, []);

  const { greeting, icon, timeString } = greetingData;

  return (
    <div className={style.HeadingBar}>
      <div className={style.HeadingBarContainer}>
        <div className={style.HeadingMainContainer}>
          <div className={style.Namearea}>
            <div className={style.starlogoarea}>
              <img src={starimg} alt="Star Logo" />
            </div>
            |<div className={style.name}>iSupply Link</div>
          </div>

          <div>
            <div className={style.CardName}>{CardName} </div>
          </div>

          <div className={style.RightSection}>
            <div className={style.GreetingInline}>
              <span className={style.GreetingIcon}>{icon}</span>
              <span className={style.GreetingText}>
                {greeting} , {vendorName}
              </span>
              <span className={style.TimeText}>{timeString}</span>
            </div>

            <div className={style.LogoutArea} onClick={handleLogout}>
              <img src={logoutimg} alt="Logout" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeadingBar;
